// B7 slice 2 (task 2026-10-28-002): the spinner's text. In its own module so Loading.tsx exports only
// the component (react-refresh/only-export-components; resolution 2026-10-28-003, AC-4).
export const translations = {
  lo: { loading: 'ກຳລັງໂຫຼດ...' },
  en: { loading: 'Loading...' },
};
